let map = {
    0: '抖音',
    1: '快手',
    2: '粉丝心选',
    3: '托管库存',
    4: '自由报单',
    5: '视频号',
    6: '共享仓库',
    7: '淘宝',
    8: '1688',
    9: '拼多多',
    10: '多平台',
    12: '蘑菇街',
    17: '有赞',
    18: '小红书',
    19: '京东',
    21: '奇门',
    22: '七鱼',
    23: '天猫'
}

const options = [
    {label: '抖音', value: 0},
    {label: '快手', value: 1},
    {label: '心选', value: 2},
    {label: '视频号', value: 5},
    {label: '淘宝', value: 7},
    {label: '1688', value: 8},
    {label: '拼多多', value: 9},
    {label: '多平台', value: 10},
    {label: '蘑菇街', value: 12},
    {label: '有赞', value: 17},
    {label: '小红书', value: 18},
    {label: '京东', value: 19},
    {label: '奇门', value: 21},
    {label: '七鱼', value: 22},
    {label: '天猫', value: 23}
]


const getPlatform = (platform) => {
    const plat = map[platform]
    return plat
}

/**
 * @param strVal 选项的val值返回字符串值
 * @param excludeFenpu 是否排除心选
 * @param excludeMulti 是否排除多平台
 */
const getOptions = (strVal, excludeFenpu, excludeMulti) => {
    //返回新的实例，防止被修改
    const resOptions = []
    const filter = []
    if (excludeFenpu) {
        filter.push(2)
    }
    if (excludeMulti) {
        filter.push(10)
    }
    const list = options.filter(op => filter.indexOf(op.value) === -1)
    list.forEach(op => {
        let label = op.label
        let value = strVal ? op.value + '' : op.value
        resOptions.push({label, value})
    })
    return resOptions
}

export default {
    getPlatform,
    getOptions,
}



// WEBPACK FOOTER //
// ./src/utils/platformUtils.js